export default {
  name: "HomePage",
  data() {
    return {
      activeProductIndex: null,
      heroStats: {
        userCount: 795,
        pluginCount: 179,
        satisfactionRate: 100,
      },
      userBase: Math.floor(Math.random() * 1001) + 2000,
      statsData: [
        { icon: "📈", value: 7143, label: "月下載平均" },
        { icon: "👥", value: 0, label: "活躍用戶" },
        { icon: "🎮", value: 179, label: "支援遊戲" },
        {
          icon: "⏰",
          value: new Date().getHours() + 17820,
          label: "在線時長(小時)",
        },
      ],
      products: [
        {
          image: require("@/assets/Image/RO.png"),
          video: "https://static.gnjoy.com.tw/video/ROZ/OpeningAnimation.mp4",
          title: "Ro仙境傳說:樂園外掛",
          description: "結合自動化練功、資源收集、數據監控、隊伍增益、即時通訊等多功能模組，全面提升冒險效率。",
          features: ["自動打怪", "自動撿物", "全圖雷達", "掉寶提示", "自動回城與補給"],
        },
        {
          image: require("@/assets/Image/vr.jpg"),
          video: "https://cmsassets.rgpub.io/sanity/files/dsfx7636/news/409ab2fc369ba5e1fe50bac10c6676d7d1365a9f.mp4",
          title: "特戰英豪外掛",
          description: "結合自瞄、透視、雷達、壓槍腳本等多模組功能，提升競技場實力。",
          features: ["CL自瞄", "ATS雷達", "CL壓槍腳本", "智能反檢測"],
        },
        {
          image: require("@/assets/Image/cs2.jpg"),
          video: "https://cdn.akamai.steamstatic.com/apps/csgo/images/csgo_react/cs2/smokes_vid2.mp4",
          title: "CS2外掛",
          description: "支援 Aimbot、Wallhack、Radar、Skin Changer 等全套作弊功能。",
          features: ["高級 Aimbot", "ESP / Wallhack", "Radar Hack", "Skin Changer", "防 VAC 探測"],
        },
        {
          image: require("@/assets/Image/AR.jpg"),
          video: "https://www.arenabreakoutinfinite.com/video/home_game_1.mp4",
          title: "暗區突圍外掛",
          description: "人物／物資透視、自瞄、範圍瞄準、背敵警告等輔助工具。",
          features: ["人物/物資透視", "範圍自瞄", "背後預警", "內核權限"],
        },
        {
          image: require("@/assets/Image/D.png"),
          video: "https://www.playdeltaforce.com/_astro/kvplay.BUGncBhe.mp4",
          title: "三角洲行動外掛",
          description: "支援透視、自瞄、雷達、無後座、秒換彈等實用功能。",
          features: ["透視 + 自瞄", "無後座力", "雷達輔助", "多層防封"],
        },
        {
          image: require("@/assets/Image/LOL.png"),
          video: "https://cmsassets.rgpub.io/sanity/files/dsfx7636/news/8ab3e227121c53aacab0c9b9f7a48adbc65db520.webm",
          title: "LOL 英雄聯盟外掛",
          description: "熱門二次元動作RPG外掛，包含自動任務、資源偵測與地圖透視等全能功能。",
          features: ["地圖全資源透視", "自動完成日常任務", "移動加速/無限體力"],
        },
      ],
      videoRefs: [],
      features: [
        {
          icon: "🛡️",
          title: "頂級安全性",
          description: "採用核心內核技術，有效繞過主流反作弊系統，確保帳號安全。",
        },
        {
          icon: "⚡",
          title: "極致性能",
          description: "輕量化設計，極低資源佔用，不影響遊戲幀數，享受流暢體驗。",
        },
        {
          icon: "⚙️",
          title: "高度客製化",
          description: "提供豐富的自訂選項，讓您可以根據需求調整功能，打造專屬輔助。",
        },
        {
          icon: "🔄",
          title: "即時更新",
          description: "專業團隊隨時監控遊戲更新，確保外掛功能第一時間適配新版本。",
        },
        {
          icon: "🎧",
          title: "24/7 在線客服",
          description: "全天候專業客服，隨時為您解答安裝、使用中的任何問題。",
        },
        {
          icon: "🌍",
          title: "支援多款遊戲",
          description: "產品線涵蓋多款熱門線上遊戲，滿足您不同的遊戲需求。",
        },
      ],
      observer: null,
    };
  },
  mounted() {
    this.createParticles();
    this.createStars(); // 我們將在這裡呼叫 createStars
    this.initHeroAnimations();
    this.initStatsObserver();
    this.statsData[1].value = this.getActiveUser();
    this.heroStats.userCount = this.statsData[1].value;

    this.activeUserInterval = setInterval(() => {
      this.statsData[1].value = this.getActiveUser();
      this.heroStats.userCount = this.statsData[1].value;
    }, 1000);
  },
  beforeUpdate() {
    this.videoRefs = [];
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    clearInterval(this.activeUserInterval);
  },
  methods: {
    toggleProductActive(index) {
      if (this.activeProductIndex === index) {
        this.pauseVideo(this.activeProductIndex);
        this.activeProductIndex = null;
      } else {
        if (this.activeProductIndex !== null) {
          this.pauseVideo(this.activeProductIndex);
        }
        this.activeProductIndex = index;
        this.playVideo(index);
      }
    },
    playVideo(index) {
      const video = this.videoRefs[index];
      if (video && video.paused) {
        video.play().catch(error => {
          console.error("Video play failed:", error);
        });
      }
    },
    pauseVideo(index) {
      const video = this.videoRefs[index];
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
    animateNumber(element, targetValue, suffix = "") {
      let startValue = 0;
      const duration = 2000;
      const startTime = performance.now();

      const updateNumber = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        if (elapsedTime < duration) {
          const progress = elapsedTime / duration;
          startValue = Math.floor(progress * targetValue);
          element.textContent = startValue.toLocaleString() + suffix;
          requestAnimationFrame(updateNumber);
        } else {
          element.textContent = targetValue.toLocaleString() + suffix;
        }
      };
      requestAnimationFrame(updateNumber);
    },
    getActiveUser() {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();

      let peakFactor = 1;
      if (hours >= 19 && hours <= 23) {
        peakFactor = 1.5 + Math.sin((hours - 19) * Math.PI / 4) * 0.2;
      } else {
        peakFactor = 1 + Math.sin(hours * Math.PI / 12) * 0.3;
      }
      const minuteFluctuation = (minutes % 15) / 15 * 50 - 25;
      return Math.floor(this.userBase * peakFactor + minuteFluctuation);
    },
    createParticles() {
      const container = this.$refs.particles;
      if (!container) return;
      const particleCount = 100;
      for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement("div");
        particle.className = "particle";
        particle.style.left = `${Math.random() * 100}%`;
        particle.style.top = `${Math.random() * 100}%`;
        particle.style.animationDelay = `${Math.random() * 6}s`;
        particle.style.transform = `scale(${Math.random() * 0.5 + 0.5})`;
        container.appendChild(particle);
      }
    },
    gotoLine() {
      window.open("https://lin.ee/GwsPMQw", "_blank");
    },
    initHeroAnimations() {
      const stats = document.querySelectorAll(".hero .stat-number");
      stats.forEach((stat) => {
        const targetValue = parseInt(stat.textContent.replace(/[^0-9]/g, ""), 10);
        const suffix = stat.textContent.includes("%") ? "%" : "";
        this.animateNumber(stat, targetValue, suffix);
      });
    },
    initStatsObserver() {
      const section = this.$refs.statsSection;
      if (!section) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const numbers = entry.target.querySelectorAll(".stats-number");
              numbers.forEach((number, index) => {
                const targetValue = this.statsData[index].value;
                this.animateNumber(number, targetValue);

              });
              this.observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.5,
        }
      );
      this.observer.observe(section);
    },
    createStars() {
      const container = this.$refs.starfieldContainer;
      if (!container) {
        console.error("最終錯誤：找不到 ref='starfieldContainer' 的容器！");
        return;
      }
      const starCount = 150;
      for (let i = 0; i < starCount; i++) {
        const star = document.createElement("div");
        star.className = "star";
        star.style.left = `${Math.random() * 100}%`;
        star.style.top = `${Math.random() * 100}%`;
        star.style.width = `${Math.random() * 2 + 1}px`;
        star.style.height = star.style.width;
        star.style.animationDelay = `${Math.random() * 3}s`;
        star.style.animationDuration = `${Math.random() * 2 + 2}s`;
        container.appendChild(star);
      }
    },
  },
};